<template>
  <div id="pageCadastroPraca">
    <v-container grid-list-x2 fluid>
      <v-layout row wrap justify-center>
        <v-flex lg6 sm12 xs12>
          <v-card>
            <v-toolbar color="pink" dark flat dense cad>
              <v-toolbar-title class="subheading">Conferência romaneio saída</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="">
              <filtro origem="Itens-nao-ficaram-em-saida"></filtro>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import Filtro from "@/components/relatorios/romaneios/diferencaItensRomaneioESaidas"
export default {
  components: {
    Filtro
  }
}
</script>
